import { render } from "./FeedPage.vue?vue&type=template&id=06a8b881"
import script from "./FeedPage.vue?vue&type=script&lang=js"
export * from "./FeedPage.vue?vue&type=script&lang=js"
script.render = render

export default script